import { ReturningHomeLgas } from 'utils/constants';
import { Values } from './initialValues';
import {
  isGreenZoneResident,
  isOrangeZoneResident,
  isReturnExemption,
  isVictorianReturningFromRedZone,
  isTransitingThroughVic,
  isRedZoneResident
} from './travel-reasons';

export const showRedZoneWarning = (values: Values) => {
  const {
    assess: {
      Depart: {
        quarantine: { fromQuarantine },
        fromAddressZone,
        fromAddress: {
          summaryData: { value }
        }
      },
      reasons: reasonCode
    }
  } = values;

  return (
    fromAddressZone === 'red' &&
    !!value &&
    !fromQuarantine &&
    (isGreenZoneResident(reasonCode) || isOrangeZoneResident(reasonCode))
  );
};

export const showOrangeZoneWarning = (values: Values) => {
  const {
    assess: {
      Depart: {
        fromAddressZone,
        fromAddress: {
          summaryData: { value }
        }
      },
      reasons: reasonCode
    }
  } = values;

  return (
    fromAddressZone === 'orange' &&
    !!value &&
    (isGreenZoneResident(reasonCode) || isRedZoneResident(reasonCode))
  );
};

export const showGreenZoneWarning = (values: Values) => {
  const {
    assess: {
      Depart: {
        fromAddressZone,
        fromAddress: {
          summaryData: { value }
        }
      },
      reasons: reasonCode
    }
  } = values;

  return (
    fromAddressZone === 'green' &&
    !!value &&
    (isOrangeZoneResident(reasonCode) || isRedZoneResident(reasonCode))
  );
};

export const showReturningHomeInvalidWarning = (values: Values) => {
  const {
    assess: {
      Depart: {
        fromAddress: {
          fullDetails: { lga }
        }
      },
      reasons: reasonCode
    }
  } = values;

  return (
    isReturnExemption(reasonCode) && lga && ReturningHomeLgas.every(repatLga => repatLga !== lga)
  );
};

export const showExtremelyRiskZone = (values: Values) => {
  const {
    assess: {
      Depart: {
        quarantine: { fromQuarantine },
        fromAddressZone,
        fromAddress: {
          summaryData: { value }
        }
      },
      reasons: reasonCode
    }
  } = values;

  return (
    fromAddressZone === 'extreme risk zone' &&
    !!value &&
    !fromQuarantine &&
    (isGreenZoneResident(reasonCode) ||
      isOrangeZoneResident(reasonCode) ||
      isVictorianReturningFromRedZone(reasonCode))
  );
};

export const showTransitInvalidWarning = (reasonCode = '', state: string) =>
  isTransitingThroughVic(reasonCode) && state === 'VIC';

export const showTransitInvalidWarningAll = (values: Values) => {
  const {
    assess: {
      Depart: { fromAddress, target, homeAddress, homeAddressIsDestination },
      reasons: reasonCode
    }
  } = values;

  return (
    isTransitingThroughVic(reasonCode) &&
    (fromAddress.fullDetails.state === 'VIC' ||
      target.fullDetails.state === 'VIC' ||
      (homeAddressIsDestination && homeAddress?.fullDetails.state === 'VIC'))
  );
};
